<div class="publish">
    
  <div class="publish__heading">
    <div>
      <h1 class="publish__title">
        Publish
      </h1>
    </div>

    <fa-icon
      class="publish__close"
      [icon]="['fas', 'times']"
      size="lg"
      title="close"
      (click)="closeDialog()">
    </fa-icon>
  </div>

  <div class="publish__contents">
    <app-publish *ngIf="bookmark" [model]="bookmark">
    </app-publish>
  </div>
</div>
